import $ from "jquery";
window.$ = window.jQuery = $;

import 'magnific-popup';

import Plyr from 'plyr';

import Splide from '@splidejs/splide';

import anime from 'animejs/lib/anime.es.js';

import 'youtube-background';

(function ($) {

	$('[data-vbg]').youtube_background({
		// 'fit-box': true
	});

	if ($('body.single-post').length > 0) {
		var setpost = true;
		sessionStorage.setItem('prev', 'frompost');
	}

	let animationElements = 'main, .button, #menu, body';
	// Initial loading state (should be blank)
	$(animationElements).addClass('loading');
	// set additional previous page class
	if (sessionStorage.getItem('prev') && !setpost) {
		$(animationElements).addClass(sessionStorage.getItem('prev'));
		sessionStorage.removeItem('prev');
	}

	// Once window has loaded, start an "animate In" function for 1 second
	$(window).load(function () {
		$(animationElements).removeClass('loading');
		$(animationElements).addClass('animateIn');
		setTimeout(function () {
			$(animationElements).addClass('loaded');
		}, 1000);
	});

	// On Click of any link, start an animate out function for 1 second before going to the page
	$('a:not(.standard-link)').on("click", function (e) {
		e.preventDefault();
		$(animationElements).addClass('animateOut');
		let link = $(this).attr('href');
		setTimeout(function () {
			window.location.href = link;
		}, 1000)
	});


	// open the popup with the video
	$('.play-title').magnificPopup({
		type: 'inline',
		midClick: true
	});

	// const players = Plyr.setup('.video-wrap');
	const player = new Plyr('#player', {
		/* options */
	});


	$('a.play-title').on('mfpOpen', function (e /*, params */) {
		console.log('opened');
		setTimeout(function () {

			player.play(); // Start playback
		}, 1000);

	});



	// accordions
	$('.accordion-items > li > a').click(function () {
		if (!$(this).hasClass('opened')) { // open
			$('.accordion-items > li > div').removeClass('expanded');
			$('.arrow').removeClass('rotated');
			$('.accordion-items > li > a').removeClass('opened');
			$(this).addClass('opened');
			$(this).next().addClass('expanded');
			$(this).find('.arrow').addClass('rotated');


		} else { // clsose
			$(this).removeClass('opened');
			$(this).next().removeClass('expanded');
			$(this).find('.arrow').removeClass('rotated');
		}
		$('html, body').delay(0).animate({
			scrollTop: $(this).parent().offset().top - 100
		}, 0);
		return false;
	});



	// fade in from browser load
	document.querySelectorAll('p, img:not(.no-load), h2, h5, h4, address, figcaption, .caption').forEach(el => {
		var animation = anime({
			targets: el,
			opacity: {
				value: [0, 1],
			},
			easing: 'easeInOutQuart',
			autoplay: false,
			duration: 100
		});
		$(window).on('load resize scroll', function () {
			var distanceFromBottom = $(window).height() - el.getBoundingClientRect().top;
			animation.seek((distanceFromBottom / 300) * animation.duration);
		});
	});

	document.querySelectorAll('.gallery-image img').forEach(el => {
		var animation2 = anime({
			targets: el,
			scale: {
				value: [1, 1.05],
			},
			easing: 'easeInOutQuart',
			autoplay: false,
			duration: 100
		});
		$(window).on('load resize scroll', function () {

			var toppos = el.getBoundingClientRect().top;
			if (toppos < 0) {
				var pospos = Math.abs(toppos);
			} else {
				var pospos = 0;
			}
			console.log(pospos);
			animation2.seek((pospos / 1000) * animation2.duration);

		});
	});




	// $(".gallery-image img").css({
	// 	transform: 'translate3d(-0%, -' + (scroll / 100) + '%, 0) scale(' + (100 + scroll / 95) / 100 + ')',
	// });


	// slider from browser load
	if (document.querySelector('.projects')) {

		var main = new Splide('.projects', {
			type: 'loop',
			perPage: 3,
			pagination: false,
			arrows: true,
			autoplay: true,
			speed: 1000,
			perMove: 1,
			focus: 'center',
			rewind: false,
			breakpoints: {
				1023: {
					perPage: 3,
					fixedWidth: '50vw',
					gap: '5vw',
				},
				768: {
					perPage: 1,
					autoplay: false,
					// padding: '20%',
				},
			}
		});

		var thumbnails = new Splide('.details', {
			type: 'fade',
			pagination: false,
			arrows: false,
			// focus: 'center',
			rewind: false,
			breakpoints: {
				768: {
					arrows: false,
				},
			}

		});

		main.sync(thumbnails);
		main.mount();
		thumbnails.mount();
	}


	$('.menu').on("click", function () {
		$("body").toggleClass("menu-open");
	});
	$('#menu .email').on("click", function () {
		$("body").addClass("menu-open");
	});



	$('.menu-item').on("click", function () {
		$(".menu-item").removeClass("current-menu-item");
		$(this).addClass("current-menu-item");
		$("body").addClass("no-scrollbar");
	});

	// plyr for all instances with class .gallery-player
	const players = Array.from(document.querySelectorAll('.gallery-player')).map((p) => new Plyr(p));



	const videoBlocks = Array.from(document.querySelectorAll('.autoplay-plyr'));
	const playersAuto = [];
	
	const setupPlayers = () => {
	  videoBlocks.forEach((block) => {
		const playerAuto = new Plyr(block, {
		  autoplay: false,
		  muted: true,
		  autopause: false,
		  controls: ['play-large'],
		}); // Add 'muted: true' to mute the video
		playersAuto.push({ playerAuto, block });
	  });
	};
	
	const isInViewport = (element) => {
	  const rect = element.getBoundingClientRect();
	  // Now it returns false only when the whole element is off the page.
	  return rect.bottom >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
	};
	
	const handleVisibilityChange = () => {
	  playersAuto.forEach(({ playerAuto, block }) => {
		if (isInViewport(block) && !playerAuto.playing) {
		  playerAuto.play();
		  playerAuto.muted = true;
		} else if (!isInViewport(block) && playerAuto.playing) {
		  playerAuto.pause();
		}
	  });
	};
	
	const handlePlayButtonClick = () => {
	  playersAuto.forEach(({ playerAuto }) => {
		if (!playerAuto.playing) {
		  playerAuto.play();
		  playerAuto.muted = true;
		}
	  });
	
	  // Remove the event listener once videos start playing
	  const playButtons = document.querySelectorAll('.plyr__control');
	  playButtons.forEach((button) => {
		button.removeEventListener('click', handlePlayButtonClick);
	  });
	};
	
	window.addEventListener('load', () => {
	  setupPlayers();
	  handleVisibilityChange();
	
	  const playButtons = document.querySelectorAll('.plyr__control');
	  playButtons.forEach((button) => {
		button.addEventListener('click', handlePlayButtonClick);
	  });
	});
	
	window.addEventListener('scroll', handleVisibilityChange);
	

	// standard plyr`
	
	const standardPlayers = Array.from(document.querySelectorAll('.standard-plyr')).map((p) => new Plyr(p));



	headerScroll();

	document.addEventListener('scroll', () => {
		headerScroll();
	});

	function headerScroll() {
		var $ = jQuery;

		scroll = $(window).scrollTop();

		if (scroll >= 30) {
			$("body").addClass("is-scrolled");
		} else {
			$("body").removeClass("is-scrolled");
		}
	}

	// more
	$('.more').click(function () {

		if (!$('.expandable').hasClass('expanded')) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(this).offset().top - 100
			}, 1000);
			$(this).addClass('rotated');
			$('.textchange').text('Less');
			$('.expandable').addClass('expanded');
			$('h1').addClass('hidden');
		} else {
			$('.expandable').removeClass('expanded');
			$(this).removeClass('rotated');
			$('.textchange').text('More');
			$('h1').removeClass('hidden');
		}
		return false;
	});



	$(window).on('resize scroll', function () {
		// var scroll = $(window).scrollTop();
		// $(".gallery-image img").css({
		// 	transform: 'translate3d(-0%, -' + (scroll / 100) + '%, 0) scale(' + (100 + scroll / 95) / 100 + ')',
		// });

		if (document.querySelector('.gallery-images')) {

			var viewportTop = $(window).scrollTop();
			var viewportHeight = $(window).height();
			var viewportBottom = (viewportTop + viewportHeight);
			// detect how vertically centered an object is

			var elementTop2 = $('.last-gal-img').offset().top;
			var elementHeight2 = $('.last-gal-img').outerHeight();
			var elementBottom2 = elementTop2 + elementHeight2;
			var totalHeight2 = Math.max(elementBottom2, viewportBottom) - Math.min(elementTop2, viewportTop);
			var heightDiff2 = totalHeight2 - viewportHeight;
			var elementInside2 = elementHeight2 - heightDiff2;
			var percent2 = parseInt(elementInside2 <= 0 ? 0 : elementInside2 / elementHeight2 * 100);
			console.log(percent2)
			// if (percent2 < 50) {

			// } 

			var a = $(".last-gal-img").offset().top;
			var b = $(".last-gal-img").height();
			var c = $(window).height();
			var d = $(window).scrollTop();
			if ((c + d) > (a + b)) {
				$('.heading').addClass('faded');
			} else {
				$('.heading').removeClass('faded');
			}



		}
	});

}(jQuery));

